<template>
  <div class="card pad10">
    <el-table :data="tableData" stripe style="width: 100%">
      <el-table-column :prop="item.prop" :label="item.label" :width="item.width" v-for="item in column">
      </el-table-column>
      <el-table-column label="审核结果">
        <template slot-scope="scope">
          <!-- 0 待审核 1 已拒绝 2 已通过 -->
          <!-- 1 审核中 2 驳回 3 已通过  -->
          <div class="status" style="color:#0EAEC1" v-show="scope.row.status==0">
            <i class="iconfont icon-shenglvehao"></i>
            <span>待审核</span>
          </div>
          <div class="status" style="color:#0EAEC1" v-show="scope.row.cancelStatus==1">
            <i class="iconfont icon-shenglvehao"></i>
            <span>审核中</span>
          </div>
          <div class="status" style="color:#1ECD11" v-show="scope.row.status==2||scope.row.cancelStatus==3">
            <i class="iconfont icon-status"></i>
            <span>已通过</span>
          </div>
          <div class="status" style="color:#DF1212;cursor: pointer;" v-show="scope.row.status==1||scope.row.cancelStatus==2" @click="showReason(scope)">
            <i class="iconfont icon-102"></i>
            <span>已驳回</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button @click.stop="detail(scope)" type="text">详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
    </el-pagination>
  </div>
</template>

<script>

export default {
  components: {},
  props: {
    column: {
      //表头
      type: Array,
      required: true,
    },
    tableData: {
      //表格数据
      type: Array,
      required: true,
    },
    total: {
      //总页数
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 10,

    };
  },
  computed: {},
  watch: {},
  methods: {
    showReason(scope) {
      let _this = this
      let content = scope.row.refuseReason ? scope.row.refuseReason : scope.row.cancelRefuseReason
      this.$confirm({
        title: "驳回理由",
        content: "<p>" + content + "</p>",
        confirm: true,
        dialogVisible: true,
        btn: {
          confirmVal: "确定",
        }
      }).then((res) => {

        //点击确定之后的处理
      }).catch((err) => {
        // console.log("no", err);
      });
    },
    detail(scope) {

      let whi = scope.row.id ? 0 : 1


      let type
      // 1讲解 2服务 3策划 4其他活动 
      if (scope.row.activityType == '1') type = 'explain'
      else if (scope.row.activityType == '2') type = 'service'
      else if (scope.row.activityType == '3') type = 'plan'
      else if (scope.row.activityType == '4') type = 'activity'
      // console.log(type)
      if (whi == 0) this.$router.push({ name: 'myApplyDetail', params: { id: scope.row.id } })
      else if (whi == 1) this.$router.push({ name: 'myApplyDetail2', params: { id: scope.row.taskSignId, type: type, other: true } })
      // console.log(scope)
    },
    conso(val) {
      // console.log(val)
    },
    consos(val) {
      // console.log(val)
    },
    handleSizeChange(val) {
      this.pageSize = val
      let params = {
        currentPage: 1,
        pageSize: val
      }
      this.$emit("get-list", params)
      // console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.currentPage = val
      let params = {
        currentPage: val,
        pageSize: this.pageSize
      }
      this.$emit("get-list", params)
      // console.log(`当前页: ${val}`);
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() { },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() { },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { } //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="less" scoped>
.status {
  display: flex;
  align-items: center;
  i {
    font-size: 22px;
    margin-right: 6px;
  }
}
</style>
